import { api } from "@/api/utils";
import { CancellationPolicyEntry } from "@givenwell/management-api";
import { useQuery } from "@tanstack/react-query";
import { SelectiveCancellationPolicyModel } from "./models";

export const cancellationPolicyQueryKey = ["cancellation-policy"];

export function useSelectiveCancellationPolicyQuery(supplierId: string) {
  return useQuery({
    queryKey: [...cancellationPolicyQueryKey, supplierId],
    queryFn: async () => {
      const policy = await api.supplier.getCancellationPolicy({ supplierId: supplierId });
      const sortedEntries = policy.cancellation_policy_entries.slice().sort((a, b) => b.hours_before - a.hours_before);
      const noRefundEntry = sortedEntries.filter(refund => refund.refund_percentage === 0)[0];
      const partialRefundEntry = sortedEntries.filter(
        refund => refund.refund_percentage > 0 && refund.refund_percentage < 100,
      )[0];
      const fullRefundEntry = sortedEntries.filter(refund => refund.refund_percentage === 100)[0];

      const toPolicyEntryModel = (entry?: CancellationPolicyEntry) => {
        return entry ? { hoursBefore: entry.hours_before, refundPercentage: entry.refund_percentage } : undefined;
      };

      const model: SelectiveCancellationPolicyModel = {
        policyId: policy.policy_id,
        version: policy.version,
        name: policy.name,
        description: policy.description ?? undefined,
        supplierId: policy.supplier_id,
        noRefund: toPolicyEntryModel(noRefundEntry),
        partialRefund: toPolicyEntryModel(partialRefundEntry),
        fullRefund: toPolicyEntryModel(fullRefundEntry),
      };
      return model;
    },
  });
}
